import { useMemo } from 'react'

import {
  selectFeatureFlagFactory,
  selectFeatureFlags
} from '../store/selectors/config'

import { useAppStoreSelector } from './useAppStoreSelector'

/**
 * Returns the list of feature flags from the store.
 * Please prefer {@link useFlag} whenever possible for a granular checks.
 */
export const useFlags = () => useAppStoreSelector(selectFeatureFlags)

export const useFlag = <T = boolean>(
  ...args: Parameters<typeof selectFeatureFlagFactory<T>>
) => {
  const selector = useMemo(() => selectFeatureFlagFactory<T>(...args), [args])

  return useAppStoreSelector(selector)
}
